var _dec, _class, _Tag;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { IconXLine } from '@instructure/ui-icons';
import { View } from '@instructure/ui-view';
import { omitProps } from '@instructure/ui-react-utils';
import { isActiveElement } from '@instructure/ui-dom-utils';
import { withStyle } from '@instructure/emotion';
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
/**
---
category: components
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let Tag = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Tag = class Tag extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.focus = () => {
      this.ref && this.ref.focus();
    };
    this.handleClick = e => {
      const _this$props = this.props,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        onClick = _this$props.onClick;
      if (disabled || readOnly) {
        e.preventDefault();
        e.stopPropagation();
      } else if (typeof onClick === 'function') {
        onClick(e);
      }
    };
    this.handleRef = element => {
      this.ref = element;
      if (typeof this.props.elementRef === 'function') {
        this.props.elementRef(element);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props2;
    (_this$props$makeStyle = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props2);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props3;
    (_this$props$makeStyle2 = (_this$props3 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props3);
  }
  get focused() {
    return isActiveElement(this.ref);
  }
  render() {
    const _this$props4 = this.props,
      className = _this$props4.className,
      dismissible = _this$props4.dismissible,
      disabled = _this$props4.disabled,
      readOnly = _this$props4.readOnly,
      text = _this$props4.text,
      title = _this$props4.title,
      onClick = _this$props4.onClick,
      margin = _this$props4.margin,
      styles = _this$props4.styles;
    const passthroughProps = View.omitViewProps(omitProps(this.props, Tag.allowedProps), Tag);
    return _jsxs(View, {
      ...passthroughProps,
      elementRef: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.tag,
      className: className,
      as: onClick ? 'button' : 'span',
      margin: margin,
      type: onClick ? 'button' : void 0,
      ...(onClick && {
        onClick: this.handleClick
      }),
      disabled: disabled || readOnly,
      display: void 0,
      title: title || (typeof text === 'string' ? text : void 0),
      "data-cid": "Tag",
      children: [_jsx("span", {
        css: styles === null || styles === void 0 ? void 0 : styles.text,
        children: text
      }), onClick && dismissible ? _jsx(IconXLine, {
        css: styles === null || styles === void 0 ? void 0 : styles.icon
      }) : null]
    });
  }
}, _Tag.displayName = "Tag", _Tag.componentId = 'Tag', _Tag.allowedProps = allowedProps, _Tag.defaultProps = {
  size: 'medium',
  dismissible: false,
  variant: 'default',
  disabled: false,
  readOnly: false
}, _Tag)) || _class);
export default Tag;
export { Tag };